<template>
    <div class="live-label" :class="liveStatusClass">
        <div class="live-indicator" />
        <span class="live-text">{{ getLabelText }}</span>
    </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
    name: 'LiveLabel',
    props: {
        /**
         * 直播狀態
         */
        isLive: {
            type: Boolean,
            required: true,
        },
    },
    setup(props) {
        // 取得i18n
        const { t } = useI18n()


        // 根據直播狀態決定樣式類別
        const liveStatusClass = computed(() => ({
            'live-label--active': props.isLive,
            'live-label--inactive': !props.isLive,
        }))
        // 根據直播狀態決定標籤文字
        const getLabelText = computed(() => props.isLive ? t('Live') : t('Idle'))


        return {
            liveStatusClass,
            getLabelText,
        }
    },
})
</script>
<style scoped lang="scss">
// 高 / padding / 圓角跟頂欄右側按鈕同一套
.live-label {
	display: flex;
	height: 28px;
	padding: 0 8px;
	justify-content: center;
	align-items: center;
	gap: 4px;
	border-radius: var(--radius-header-button);

	// 直播中：圓形指示點
	&--active {
		background-color: var(--ui-ignite);
		border: 1px solid var(--ui-ignite);

		.live-indicator {
			width: 10px;
			height: 10px;
			border-radius: 50%;
			background-color: #fff;
			animation: pulse 2s ease-out infinite;
		}
	}

	// 離線：方形指示點，不只靠顏色區分狀態
	&--inactive {
		background-color: var(--ui-grey-lighter);
		border: 1px solid var(--ui-grey-lighter);

		.live-indicator {
			width: 10px;
			height: 10px;
			border-radius: 2px;
			background-color: var(--ui-page);
		}
	}

	.live-text {
		color: var(--ui-page);
		font-size: 14px;
		font-weight: 500;
		line-height: 1;
		letter-spacing: -0.1px;
	}
}

@keyframes pulse {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	25% {
		transform: scale(1.25);
		opacity: 0.7;
	}
	50% {
		transform: scale(1);
		opacity: 1;
	}
	100% {
		transform: scale(1);
		opacity: 1;
	}
}
</style>
